
import { rootComputed } from '@/store/common/helpers';
import { setLpad, setChartBgColor, setChartBdColor } from '@/qmsUtils/'; 
import moment from 'moment';

export default {
	mdjYGraphCols_: (state, getters, rootState, rootGetters) => {
		let cols = [];
		let searcCuRslt = Number(state.searchParams.searchDate);
		let searcBfRslt = searcCuRslt - 1;
		let currYear = searcCuRslt.toString().substring(2, 4);
		let cuRsltLabel = currYear + `${rootGetters['commonStore/getMessage_']('QWCC001451')}` + ' ';
		let bfRsltLabel = searcBfRslt.toString().substring(2, 4) + `${rootGetters['commonStore/getMessage_']('QWCC001451')}` + ' ';
		let thisYear = moment().format('YYYY'); 
		let thisDt = moment().format('MM'); 
		let searchYear = searcCuRslt.toString();

		let saleRegnNm = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC000059')}`, 
			prop: 'saleRegnNm',
			width: '130px',
			align: 'center',
			sortable: false
		};
		let itemNm = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC002128')}`, 
			prop: 'itemNm',
			minWidth: '100px',
			align: 'center',
			sortable: false
		};
		let bfRslt = {
			label: bfRsltLabel + `${rootGetters['commonStore/getMessage_']('QWCC001450')}`, //去年实绩
			prop: 'bfRslt',
			minWidth: '100px',
			align: 'center',
			sortable: false,
			//custom: true,
			//labelClassName: 'bfRslt'
		};
		let cuRslt = {
			label: cuRsltLabel + `${rootGetters['commonStore/getMessage_']('QWCC001450')}`, //今年实绩
			prop: 'cuRslt',
			minWidth: '100px',
			align: 'center',
			sortable: false,
			//custom: true,
			//labelClassName: 'cuRslt'
		};

		cols.push(saleRegnNm);
		cols.push(itemNm);
		cols.push(bfRslt);
		cols.push(cuRslt);
		let month =0;
		let pclProp = '';
		let labelMom = '';
		if (thisYear != searchYear) {
			for ( month = 1; month < 13; month++) {
				pclProp = 'mm' + setLpad(month, 2, '0');
				labelMom = setLpad(month, 2, '0');
				var newCol = {
					//label: cuRsltLabel + labelMom + `${rootGetters['commonStore/getMessage_']('SWCC000365')}`,
					label: currYear + '.' + labelMom,
					prop: pclProp,
					minWidth: '100px',
					align: 'center',
					sortable: false,
					custom: true,
					labelClassName: searchYear + labelMom
				};
				cols.push(newCol);
			}
		} else {
			if (thisDt > 8) {
				for ( month = 1; month < 13; month++) {
					 pclProp = 'mm' + setLpad(month, 2, '0');
					 labelMom = setLpad(month, 2, '0');
					var newCol = {
						//label: cuRsltLabel + labelMom + `${rootGetters['commonStore/getMessage_']('SWCC000365')}`,
						label: currYear + '.' + labelMom,
						prop: pclProp,
						minWidth: '100px',
						align: 'center',
						sortable: false,
						custom: true,
						labelClassName: searchYear + labelMom
					};
					cols.push(newCol);
				}
			} else {
				
				for ( month = 0; month < 12; month++) {
					let pclSearchDate = moment(searchYear + '01').subtract(0, 'M').add(month, 'M').format('YYYYMM'); //수동테스트
					let pclYear = pclSearchDate.toString().substring(2, 4);
					let pclMonth = pclSearchDate.toString().substring(4, 6);
					let pclmonthm = month + 1;
					 pclProp = 'mm' + setLpad(pclmonthm, 2, '0');
					 labelMom = setLpad(pclmonthm, 2, '0');
					var newCol = {
						//label: pclYear + `${rootGetters['commonStore/getMessage_']('QWCC001451')}` + ' ' + pclMonth + `${rootGetters['commonStore/getMessage_']('SWCC000365')}`,
						label: pclYear + '.' + pclMonth,
						prop: pclProp,
						minWidth: '100px',
						align: 'center',
						sortable: false,
						custom: true,
						labelClassName: searchYear + labelMom
					};
					cols.push(newCol);
				}
			}
		}
		
		return cols;
	},
	
	LineChartLabel_: (state, getters, rootState, rootGetters) => {
		let cols = [];
		let searcCuRslt = Number(state.searchParams.searchDate);
		let cuRsltLabel = searcCuRslt.toString().substring(2, 4) + `${rootGetters['commonStore/getMessage_']('QWCC001451')}` + ' ';
		let thisYear = moment().format('YYYY');
		let thisDt = moment().format('MM');
		let searchYear = searcCuRslt.toString();

		for (let month = 1; month < 13; month++) {
			var newCol = month + `${rootGetters['commonStore/getMessage_']('SWCC000365')}`;
			cols.push(newCol);
		}
		return cols;
	},
	
	lineDataSet_: ({ graphLineChartInfo }) => {
		let cols = [];
		let bgColors = ['rgba(250, 86, 86, 0.86)', 'rgba(105, 119, 247, 0.86)', 'rgba(243, 231, 68, 0.95)', 'rgba(240, 150, 115, 0.73)'];
		let finalMaxBarVal = 0;
		for (let i = 0; i < graphLineChartInfo.length; i++) {
			let newCol = {};
			if(graphLineChartInfo[i].type == 'bar'){
				let currMaxBarVal = Math.max.apply(null, graphLineChartInfo[i].data);
				if(currMaxBarVal > finalMaxBarVal){
					finalMaxBarVal = currMaxBarVal;
				}
				newCol = {
					type: graphLineChartInfo[i].type,
					label: graphLineChartInfo[i].itemNm,
					data: graphLineChartInfo[i].data,
					backgroundColor: bgColors[i],
				};
			}else{
				let lineData = graphLineChartInfo[i].data.map(function(num) {
					return num + finalMaxBarVal;
				});
				newCol = {
					type: graphLineChartInfo[i].type,
					label: graphLineChartInfo[i].itemNm,
					data: lineData,
					barMaxData: finalMaxBarVal,
					borderColor: bgColors[i],
					backgroundColor: 'white',
				};
			}
			cols.push(newCol);
		} 
		return cols;
	},

	stackedLabel_: (state, getters, rootState, rootGetters) => {
		let searcCuRslt = Number(state.searchParams.searchDate);
		let searcBfRslt = searcCuRslt - 1;
		let cuRsltLabel = searcCuRslt.toString().substring(2, 4);
		let bfRsltLabel = searcBfRslt.toString().substring(2, 4);
		let barbRsltLabel =
			bfRsltLabel +
			`${rootGetters['commonStore/getMessage_']('QWCC001451')}` +
			' ' +
			`${rootGetters['commonStore/getMessage_']('QWCC001450')}`;
		let barCuRsltLabel =
			cuRsltLabel +
			`${rootGetters['commonStore/getMessage_']('QWCC001451')}` +
			' ' +
			`${rootGetters['commonStore/getMessage_']('QWCC001450')}`;

		let labelArray = [];

		labelArray.push(barbRsltLabel);
		labelArray.push(barCuRsltLabel);
		return labelArray;
	},

	stackedDataSet_: ({ graphBarStackChartInfo }) => {
		let cols = [];
		for (let i = 0; i < graphBarStackChartInfo.length; i++) {
			let idxScn = graphBarStackChartInfo[i].idxScn;
			let bfCnt = graphBarStackChartInfo[i].bfCnt;
			let cuCnt = graphBarStackChartInfo[i].cuCnt;
			let cuYy = graphBarStackChartInfo[i].cuYy;
			let newCol = {
				type: 'bar',
				data: [bfCnt, cuCnt],
				dataKey: [idxScn],
				backgroundColor: 'rgba(245, 51, 93, 0.2)'
				//borderColor: setChartBdColor(i),
				//borderWidth: 1
			};
			cols.push(newCol);
		}

		return cols;
	},
	monthlabel_: () => {
		let monthlabel = [];
		for (let i = 1; i < 13; i++) {
			let label = 'mm' + setLpad(i, 2, '0');
			monthlabel.push(label);
		}
		return monthlabel;
	}
};
